import React from 'react';
import CrudPage from '../../components/CrudPage';
import { ipLoggingApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'id' },
  { header: 'IP Address', field: 'ipAddress' },
  { header: 'Investor ID', field: 'investorId' },
  { header: 'Action', field: 'action' },
  { header: 'Created', field: 'createdAt', type: 'date' },
];

const formFields = [
  { name: 'ipAddress', label: 'IP Address', type: 'text', required: true },
  { name: 'investorId', label: 'Investor ID', type: 'text' },
  { name: 'action', label: 'Action', type: 'text' },
];

const IpLoggingPage = () => (
  <CrudPage
    title="IP Logging"
    subtitle="View IP activity logs"
    api={ipLoggingApi}
    columns={columns}
    formFields={formFields}
    idField="id"
    searchField="ipAddress"
  />
);

export default IpLoggingPage;
